export default "__VITE_ASSET__Eip9VWwS__"